"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("react-bootstrap/lib/Button"));

var _Glyphicon = _interopRequireDefault(require("react-bootstrap/lib/Glyphicon"));

var _rcSlider = _interopRequireDefault(require("rc-slider"));

var _RcSliderStyle = _interopRequireDefault(require("./RcSliderStyle"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var VerticallyAlignedSpan = _styledComponents["default"].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  vertical-align: middle;\n"])));

var AddCoexpressedGenesButton = function AddCoexpressedGenesButton(_ref) {
  var showCoexpressionsCallback = _ref.showCoexpressionsCallback;
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    bsSize: "xsmall",
    onClick: function onClick() {
      return showCoexpressionsCallback(10);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Glyphicon["default"], {
    glyph: "th"
  }), /*#__PURE__*/_react["default"].createElement(VerticallyAlignedSpan, null, " Add similarly expressed genes"));
};

AddCoexpressedGenesButton.propTypes = {
  showCoexpressionsCallback: _propTypes["default"].func.isRequired
};

var SliderContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 250px;\n  margin: 15px;\n  padding-bottom: 20px;\n"])));

var CoexpressedGenesSlider = function CoexpressedGenesSlider(_ref2) {
  var geneName = _ref2.geneName,
      numCoexpressionsAvailable = _ref2.numCoexpressionsAvailable,
      numCoexpressionsVisible = _ref2.numCoexpressionsVisible,
      showCoexpressionsCallback = _ref2.showCoexpressionsCallback;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      fontSize: "0.75rem"
    }
  }, "Display genes with similar expression to ", geneName, ":"), /*#__PURE__*/_react["default"].createElement(SliderContainer, null, /*#__PURE__*/_react["default"].createElement(_rcSlider["default"], {
    min: 0,
    max: numCoexpressionsAvailable,
    onAfterChange: showCoexpressionsCallback,
    marks: _defineProperty({
      0: "off",
      10: "10"
    }, numCoexpressionsAvailable, numCoexpressionsAvailable),
    included: false,
    defaultValue: numCoexpressionsVisible
  })));
};

CoexpressedGenesSlider.propTypes = _objectSpread({
  geneName: _propTypes["default"].string.isRequired,
  numCoexpressionsVisible: _propTypes["default"].number.isRequired,
  numCoexpressionsAvailable: _propTypes["default"].number.isRequired
}, AddCoexpressedGenesButton.propTypes);

var CoexpressionOption = function CoexpressionOption(_ref4) {
  var geneName = _ref4.geneName,
      numCoexpressionsVisible = _ref4.numCoexpressionsVisible,
      numCoexpressionsAvailable = _ref4.numCoexpressionsAvailable,
      showCoexpressionsCallback = _ref4.showCoexpressionsCallback;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: "30px"
    }
  }, numCoexpressionsAvailable ? numCoexpressionsVisible ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_RcSliderStyle["default"], null), /*#__PURE__*/_react["default"].createElement(CoexpressedGenesSlider, {
    geneName: geneName,
    numCoexpressionsVisible: numCoexpressionsVisible,
    numCoexpressionsAvailable: numCoexpressionsAvailable,
    showCoexpressionsCallback: showCoexpressionsCallback
  })) : /*#__PURE__*/_react["default"].createElement(AddCoexpressedGenesButton, {
    showCoexpressionsCallback: showCoexpressionsCallback
  }) : /*#__PURE__*/_react["default"].createElement("span", null, "No genes with similar expression to ", geneName, " could be found"));
};

CoexpressionOption.propTypes = _objectSpread({}, CoexpressedGenesSlider.propTypes);
var _default = CoexpressionOption;
exports["default"] = _default;